import { createFileRoute } from '@tanstack/react-router'
import { ProjectDetail } from '@/modules/project-hub/pages/ProjectDetail'

export const Route = createFileRoute('/projects/$projectId')({
  component: ProjectDetail,
})
